import React, { useState, useEffect } from "react";
import MyCard from "../../../tools/MyCard";
import { SolidButton } from "../../../global/SolidButton";
import { Eraser, FilePlusCorner, Link } from "lucide-react";
import MyTabs from "../../../tools/MyTabs";
import RequiredParams from "../../../util/RequiredParams";
import SignatureVerificationCard from "../../../global/SignatureVerificationCard";
import IPWhitelistingCard from "../../../global/IPWhitelistingCard";

export default function AddCallback() {
  const [preview, setPreview] = useState({
    platform: "Not Set",
    source: "Not Set",
    apiType: "GET",
    coin: "Not Set",
    userField: "Not Set",
    txTemplate: "Not Set",
    titleField: "Not Set",
    defaultTitle: "Not Set",
    maxCoins: "Unlimited",
    paramsCount: 0,
    params: [],
    signature: { enabled: false, salt: "", template: "" },
    whitelist: { enabled: false, ipList: [] },
  });

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail || {};
      setPreview((p) => ({ ...p, ...d }));
    };
    window.addEventListener("previewUpdate", handler);
    return () => window.removeEventListener("previewUpdate", handler);
  }, []);
  return (
    <div className="w-full min-h-screen  xl-flex">
      <div className="flex items-center justify-end"></div>
      <div className="flex-1 transition-all duration-300 ease-in-out ">
        <div className="min-h-screen ">
          <div className="grid grid-cols-1 lg:grid-cols-22 gap-4  ">
            {/* section first */}
            <div className="md:col-span-14 ">
              <MyTabs
                className="justify-between ml-auto items-center"
                position="left"
                children={
                  <>
                    <div className="ml-auto flex flex-row items-center space-x-4">
                      <Eraser
                        className="w-9 h-9 p-[6px] cursor-pointer text-slate-600 dark:text-slate-300 rounded-lg hover:bg-gray-400/20"
                        strokeWidth={1.25}
                      />
                      <SolidButton
                        onClick={() =>
                          window.dispatchEvent(new Event("createCallback"))
                        }
                      >
                        <FilePlusCorner className="h-4 w-4" />
                        <span>Create Callback</span>
                      </SolidButton>
                    </div>
                  </>
                }
                tabs={[
                  {
                    label: "Manual Configuration",
                    content: <ManualConfig />,
                  },
                  {
                    label: "Import Configuration",
                    content: <ImportConfig />,
                  },
                ]}
              ></MyTabs>
            </div>

            {/* section second */}
            <MyCard className="p-4 md:col-span-8  w-full sticky h-fit mt-14">
              <div className="flex  items-center justify-start space-x-2">
                <Link className="text-blue-600 w-4 h-4" strokeWidth={1.2} />
                <span className="text-[13px] font-semibold font-sans  text-slate-600 dark:text-slate-200">
                  Callback Preview
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Platform:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.platform}
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Source:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.source}
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Method:
                </span>
                <span className="text-[13px] bg-green-400/26 px-2 py-[1px] rounded-full text-green-800 font-semibold font-sans dark:text-slate-300">
                  {preview.apiType}
                </span>
              </div>
              {/* line */}
              <div className="border-b-1 mt-4 border-gray-400/40 dark:border-gray-200/20" />
              {/* Parameters */}
              <span className="text-[13px] font-semibold font-sans text-slate-700 dark:text-white">
                Parameters
              </span>
              {/* line */}
              <div className="border-b-1 my-4 border-gray-400/40 dark:border-gray-200/20" />
              <div className="mt-2">
                {preview.params && preview.params.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {preview.params.map((p, i) => (
                      <span
                        key={i}
                        className="text-xs px-2 py-1 dark:text-slate-300 text-slate-700 bg-slate-100 dark:bg-slate-800 rounded"
                      >
                        {p}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-xs text-slate-400">No parameters set</p>
                )}
              </div>
              {/* Field Mapping */}
              <span className="text-[13px] font-semibold font-sans text-slate-700 dark:text-white">
                Field Mapping
              </span>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Coins:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.coin}
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  User:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.userField}
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Transaction:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.txTemplate}
                </span>
              </div>
              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Title:
                </span>
                <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
                  {preview.titleField !== "Not Set"
                    ? preview.titleField
                    : preview.defaultTitle}
                </span>
              </div>
              <Line />
              <div>
                <Title>Default Title:</Title>
              </div>
              <Value>{preview.defaultTitle}</Value>
              <Line />
              <PointCompo
                title={"Max Coins:"}
                value={
                  preview.maxCoins === 0 || preview.maxCoins === "0"
                    ? "Unlimited"
                    : preview.maxCoins
                }
              />
              <Line />

              {/* Signature -------------------------- */}
              {preview.signature.enabled && (
                <>
                  <div className="flex items-center  justify-between mt-2">
                    <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                      Signature:
                    </span>
                    <span className="text-[13px] text-green-600 font-semibold font-sans dark:text-green-400">
                      {preview.signature?.enabled ? "Enable" : "Disabled"}
                    </span>
                  </div>
                  <PointCompo
                    title={"Salt:"}
                    value={preview.signature?.salt || "Not Set"}
                  />
                  <PointCompo
                    title={"Template:"}
                    value={preview.signature?.template || "Not Set"}
                  />
                  <Line />
                </>
              )}

              {/* IP Whitelist-------------------------- */}
              {preview.whitelist.enabled && ( 
                <>
                  <div className="flex items-center  justify-between mt-2">
                    <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                      IP Whitelist:
                    </span>
                    <span className="text-[13px] text-green-600 font-semibold font-sans dark:text-green-400">
                      {preview.whitelist?.enabled ? "Enable" : "Disabled"}
                    </span>
                  </div>
                  <PointCompo
                    title={"Allowed IPs:"}
                    value={`${
                      (preview.whitelist?.ipList || []).length
                    } Addresses`}
                  />
                  <div className="text-[9px] font-light text-slate-500 flex flex-col">
                    {(preview.whitelist?.ipList || [])
                      .slice(0, 5)
                      .map((ip, i) => (
                        <span key={i}>{ip}</span>
                      ))}
                  </div>
                  <Line />
                </>
              )}

              <div className="flex items-center  justify-between mt-2">
                <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
                  Status:
                </span>

                <span className="text-[13px] text-green-600 font-semibold font-sans dark:text-green-400">
                  ✓⃝ Active
                </span>
              </div>
              {/* Config JSON */}
              <span className="text-[13px] font-semibold font-sans text-slate-700 dark:text-white">
                Config JSON
              </span>
              <div className="w-full h-40 bg-slate-400/20 mt-2 rounded-lg p-2 overflow-auto">
                <code className="whitespace-pre-wrap text-xs  ">
                  {JSON.stringify(preview, null, 2)}
                </code>
              </div>
            </MyCard>
          </div>
        </div>
      </div>
    </div>
  );
}

export const ManualConfig = () => {
  const [apiType, setApiType] = useState("POST"); // default
  const [error, setError] = useState(false);
  const [enabled, setEnabled] = useState(true); // default ON
  const [coin, setCoin] = useState("");
  const [userField, setUserField] = useState("");
  const [txTemplate, setTxTemplate] = useState("");
  const [titleField, setTitleField] = useState("");
  const [defaultTitle, setDefaultTitle] = useState("");
  const [source, setSource] = useState("");
  const [platform, setPlatform] = useState("");
  const [params, setParams] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [maxCoins, setMaxCoins] = useState("0");
  const [signature, setSignature] = useState({
    enabled: false,
    salt: "",
    template: "",
  });
  const [whiteIp, setWhiteIp] = useState({
    enabled: false,
    ipList: [],
  });

  const createCallback = async () => {
    const errs = {};
    if (!source.trim()) errs.source = true;
    if (!platform.trim()) errs.platform = true;
    if (!apiType) errs.apiType = true;
    if (!params || params.length === 0) errs.params = true;
    if (!coin.trim()) errs.coin = true;
    if (!userField.trim()) errs.userField = true;
    if (!txTemplate.trim()) errs.txTemplate = true;
    if (!titleField.trim()) errs.titleField = true;
    if (maxCoins !== "" && (isNaN(Number(maxCoins)) || Number(maxCoins) < 0))
      errs.maxCoins = true;

    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    const payload = {
      source,
      platform,
      apiType,
      enabled,
      coin,
      userField,
      txTemplate,
      titleField,
      defaultTitle,
      maxCoins: maxCoins === "" ? 0 : Number(maxCoins),
      params,
      signature,
      whitelist: whiteIp,
    };

    try {
      setSubmitting(true);
      const res = await fetch("/api/apps/callbacks", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        console.error("Create callback failed", res.status);
      } else {
        const data = await res.json().catch(() => null);
        console.log("Callback created", data || payload);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  React.useEffect(() => {
    const handler = () => createCallback();
    window.addEventListener("createCallback", handler);
    return () => window.removeEventListener("createCallback", handler);
  }, [
    source,
    platform,
    apiType,
    enabled,
    coin,
    userField,
    txTemplate,
    titleField,
    defaultTitle,
    params,
    signature,
    whiteIp,
  ]);

  // dispatch preview updates for realtime sidebar
  React.useEffect(() => {
    const payload = {
      platform,
      source,
      apiType,
      coin: coin || "Not Set",
      userField: userField || "Not Set",
      txTemplate: txTemplate || "Not Set",
      titleField: titleField || "Not Set",
      defaultTitle: defaultTitle || "Not Set",
      maxCoins: maxCoins === "" ? 0 : Number(maxCoins),
      paramsCount: params ? params.length : 0,
      params: params || [],
      signature,
      whitelist: whiteIp,
    };

    window.dispatchEvent(new CustomEvent("previewUpdate", { detail: payload }));
  }, [
    platform,
    source,
    apiType,
    coin,
    userField,
    txTemplate,
    titleField,
    defaultTitle,
    maxCoins,
    params,
    signature,
    whiteIp,
  ]);

  return (
    <MyCard className="p-4  flex flex-col">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="">
          <label
            htmlFor="source"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Source*
          </label>
          <div className="relative">
            <input
              type="text"
              name="cb_source"
              value={source}
              onChange={(e) => setSource(e.target.value)}
              placeholder="e.g.,Mobile Games , Surveys , Videos Ads"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.source && (
              <p className="text-red-500 text-xs mt-1">Source is required</p>
            )}
          </div>
        </div>
        <div className="">
          <label
            htmlFor="platform"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Platform*
          </label>
          <div className="relative">
            <input
              type="text"
              name="cb_pf"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              placeholder="e.g.,AdJoy , PubScale , IronSource , AdGate Media"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.platform && (
              <p className="text-red-500 text-xs mt-1">Platform is required</p>
            )}
          </div>
        </div>
        {/* HTTP Method */}
        <div className="">
          <label
            htmlFor="apiType"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            HTTP Method*
          </label>

          <div className="relative mt-2">
            <select
              id="apiType"
              name="apiType"
              value={apiType}
              onChange={(e) => setApiType(e.target.value)}
              className="w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md
        text-slate-900 dark:text-white text-xs placeholder-slate-500
        focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
        
        border border-slate-200 dark:border-slate-700"
            >
              <option value="POST">POST – Request Body</option>
              <option value="GET">GET – Query Parameters</option>
            </select>
          </div>

          {error && (
            <p className="text-red-500 text-xs mt-1">API Method is required</p>
          )}
        </div>
        {/* Enable Offer Count */}
        <div className="flex items-center gap-3 mt-8">
          {/* Switch */}
          <button
            type="button"
            onClick={() => setEnabled(!enabled)}
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300
      ${enabled ? "bg-blue-600" : "bg-slate-300"}`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300
        ${enabled ? "translate-x-[15px]" : "translate-x-[2px]"}`}
            />
          </button>

          {/* Label */}
          <span className="text-xs text-slate-700 dark:text-slate-200">
            Enable Offer count
          </span>
        </div>
        {/* require parameters */}
        <RequiredParams
          className="sm:col-span-2"
          onChange={(p) => setParams(p)}
        />
        {errors.params && (
          <p className="text-red-500 text-xs mt-1 sm:col-span-2">
            At least one parameter is required
          </p>
        )}
        {/* Coin Field */}
        <div className="">
          <label
            htmlFor="coin"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Coins Field*
          </label>
          <div className="relative">
            <input
              type="text"
              id="coin"
              name="cb_coin"
              value={coin}
              onChange={(e) => setCoin(e.target.value)}
              placeholder="e.g., coins,amount,reward"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.coin && (
              <p className="text-red-500 text-xs mt-1">
                Coins field is required
              </p>
            )}
          </div>
        </div>
        {/* User Field* */}
        <div className="">
          <label
            htmlFor="userField"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            User Field*
          </label>
          <div className="relative">
            <input
              type="text"
              id="userField"
              name="cb_user_field"
              value={userField}
              onChange={(e) => setUserField(e.target.value)}
              placeholder="e.g., user_id, uuid, external_id"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.userField && (
              <p className="text-red-500 text-xs mt-1">
                User field is required
              </p>
            )}
          </div>
        </div>
        {/* Transaction ID Template */}
        <div className="">
          <label
            htmlFor="txTemplate"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Transaction ID Template*
          </label>
          <div className="relative">
            <input
              type="text"
              id="txTemplate"
              name="cb_tx_template"
              value={txTemplate}
              onChange={(e) => setTxTemplate(e.target.value)}
              placeholder="e.g., md5({transx}.{transaction_id})"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.txTemplate && (
              <p className="text-red-500 text-xs mt-1">
                Transaction ID is required
              </p>
            )}
          </div>
        </div>

        {/* Title Field */}
        <div className="">
          <label
            htmlFor="titleField"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Title Field*
          </label>
          <div className="relative">
            <input
              type="text"
              id="titleField"
              name="cb_title_field"
              value={titleField}
              onChange={(e) => setTitleField(e.target.value)}
              placeholder="e.g., title, offer_name(optional)"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.titleField && (
              <p className="text-red-500 text-xs mt-1">
                Title field is required
              </p>
            )}
          </div>
        </div>

        {/* Default Title */}
        <div className="">
          <label
            htmlFor="defaultTitle"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Default Title
          </label>
          <div className="relative">
            <input
              type="text"
              id="defaultTitle"
              name="cb_default_title"
              value={defaultTitle}
              onChange={(e) => setDefaultTitle(e.target.value)}
              placeholder="e.g., Offer Complete"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.defaultTitle && (
              <p className="text-red-500 text-xs mt-1">
                Default title is recommended
              </p>
            )}
          </div>
        </div>
        {/* Max Coins (0 = unlimited) */}
        <div className="">
          <label
            htmlFor="maxCoins"
            className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
          >
            Max Coins (0 = unlimited)
          </label>
          <div className="relative">
            <input
              type="number"
              id="maxCoins"
              name="cb_max_coins"
              value={maxCoins}
              onChange={(e) => setMaxCoins(e.target.value)}
              min={0}
              placeholder="e.g., 0"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.maxCoins && (
              <p className="text-red-500 text-xs mt-1">
                Max coins must be a number ≥ 0
              </p>
            )}
          </div>
        </div>
        {/* signature verifications */}
        <SignatureVerificationCard
          className="sm:col-span-2"
          onChange={(s) => setSignature(s)}
          initial={signature}
        />

        {/* IP Whitelist */}
        <IPWhitelistingCard
          initial={whiteIp}
          className={"sm:col-span-2"}
          onChange={(w) => setWhiteIp(w)}
        />
      </div>
    </MyCard>
  );
};

export const ImportConfig = () => {
  return <MyCard className="p-4 " />;
};

export const Line = () => {
  return (
    <div className="border-b-1 my-4 border-gray-400/40 dark:border-gray-200/20" />
  );
};

export const Title = ({ children }) => {
  return (
    <span className="text-sm font-medium font-sans text-slate-500 dark:text-slate-300">
      {children}
    </span>
  );
};
export const Value = ({ children }) => {
  return (
    <span className="text-[13px] text-slate-800 font-semibold font-sans dark:text-slate-300">
      {children}
    </span>
  );
};

export const PointCompo = ({ title, value }) => {
  return (
    <div className="flex items-center  justify-between mt-2">
      <Title>{title}</Title>
      <Value>{value}</Value>
    </div>
  );
};
